import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import config from 'services/config'

import socialLoginApi from '../../../services/api/socialLogin'
import { ReactComponent as MicrosoftLogo } from './microsoft-logo.svg'
import styles from './Microsoft.module.scss'

const LoginWithMicrosoftButton = ({ onSuccess, onError }) => {
  const clientId = config.microsoftClientId
  const tenantId = config.microsoftTenantId

  const msalConfig = {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`
    }
  }
  const msalInstance = new PublicClientApplication(msalConfig)

  const login = async () => {
    try {
      const data = await msalInstance.loginPopup(msalConfig.auth)
      if (data === null || data === undefined || data === '') return

      socialLoginApi
        .microsoft({
          MicrosoftIdToken: data.idToken
        })
        .then(res => {
          onSuccess && onSuccess(res)
        })
        .catch(err => {
          onError && onError(err)
        })
    } catch (error) {
      console.warn(error)
    }
  }

  return (
    <MsalProvider instance={msalInstance}>
      <button onClick={login} className={styles.microsoftLoginButton}>
        <MicrosoftLogo />
        Sign in with Microsoft
      </button>
    </MsalProvider>
  )
}

export default LoginWithMicrosoftButton
